<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="32"
    height="31"
    viewBox="0 0 32 31"
  >
    <defs>
      <path
        id="82eqa"
        d="M1358.36 178.99c-.13.15-.8.07-1.33-.17a.62.62 0 0 0-.59.06.63.63 0 0 0-.28.52v12.8c0 .2-.16.37-.35.37h-7.04v-10.41a.63.63 0 0 0-.62-.63h-6.47a.63.63 0 0 0-.62.63v10.41h-7.03c-.2 0-.35-.17-.35-.37v-12.8a.63.63 0 0 0-.88-.58c-.47.22-1.2.33-1.33.17a1 1 0 0 1 .11-1.4l12.72-11.1a.9.9 0 0 1 1.2 0l.14.1 12.6 11.01a1 1 0 0 1 .12 1.39zm.7-2.34l-12.7-11.11a.57.57 0 0 0-.16-.1 2.14 2.14 0 0 0-2.72.1l-12.71 11.1c-.92.8-1.03 2.21-.26 3.15.49.6 1.3.6 1.92.47v11.94c0 .9.71 1.63 1.6 1.63h7.66c.34 0 .62-.28.62-.63V182.8h5.21v10.41c0 .35.28.63.63.63h7.66c.88 0 1.6-.73 1.6-1.63v-11.94c.62.12 1.43.13 1.91-.47.77-.94.66-2.35-.25-3.14z"
      />
    </defs>
    <g>
      <g transform="translate(-1329 -164)">
        <use fill="#363636" xlink:href="#82eqa" />
        <use
          fill="#fff"
          fill-opacity="0"
          stroke="#363636"
          stroke-miterlimit="50"
          stroke-width=".5"
          xlink:href="#82eqa"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TheHomeIcon',
};
</script>
